module.exports = __webpack_public_path__ + "static/media/Aresteas.96d4a6b3.jpg";